import React, { useState, useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { romanticMessages } from '../data/messages';
import '../styles/RandomMessage.css';

const RandomMessage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showMessage, setShowMessage] = useState(false);
  const boxRef = useRef(null);

  const openMessage = () => {
    const randomIndex = Math.floor(Math.random() * romanticMessages.length);
    setCurrentIndex(randomIndex);
    setShowMessage(true);
  };

  const prev = (e) => {
    e.stopPropagation();
    setCurrentIndex((i) => (i - 1 + romanticMessages.length) % romanticMessages.length);
  };

  const next = (e) => {
    e.stopPropagation();
    setCurrentIndex((i) => (i + 1) % romanticMessages.length);
  };

  const handleOverlayClick = (e) => {
    if (boxRef.current && !boxRef.current.contains(e.target)) {
      setShowMessage(false);
    }
  };

  return (
    <div className="random-message-section">
      <Button
        onClick={openMessage}
        className="message-button"
        variant="outline"
        disabled={showMessage}
      >
        Sana bir mesajım var
      </Button>

      {showMessage && (
        <div className="message-overlay" onClick={handleOverlayClick}>
          <div className="message-display fade-in-slide" ref={boxRef}>
            <div className="message-body">
              <button onClick={prev} className="message-nav" aria-label="Önceki mesaj">
                <ChevronLeft className="nav-icon" />
              </button>

              <p className="message-text">{romanticMessages[currentIndex]}</p>

              <button onClick={next} className="message-nav" aria-label="Sonraki mesaj">
                <ChevronRight className="nav-icon" />
              </button>
            </div>

            <div className="message-dots">
              {romanticMessages.map((_, i) => (
                <span
                  key={i}
                  className={`message-dot${i === currentIndex ? ' active' : ''}`}
                  onClick={(e) => { e.stopPropagation(); setCurrentIndex(i); }}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RandomMessage;
